module.exports = __webpack_public_path__ + "img/plane.be5030ca.webp";